import { render, staticRenderFns } from "./ApprovedSsidList.vue?vue&type=template&id=36a9bff6&"
import script from "./ApprovedSsidList.vue?vue&type=script&lang=js&"
export * from "./ApprovedSsidList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports